<template>
    <div>
        <!-- Two-way Data-Binding -->
        <quill-editor
                v-model="content"
                ref="myQuillEditor"
                :options="editorOption"
                @focus="onEditorFocus($event)"
                @blur="onEditorBlur($event)"
                @change="onEditorChange($event)"
                class="editor"
        ></quill-editor>
        <Upload v-if="isupload" :config="{total:1}" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    // import ImageResize from 'quill-image-resize-module'
    import { quillEditor } from 'vue-quill-editor'
    import Upload from '@/components/file/Upload';
    // Quill.register('modules/imageResize', ImageResize)

    // 工具栏配置
    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
        ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
        [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
        [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
        [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
        [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
        [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
        [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
        [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
        [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
        [{ font: [] }], // 字体种类-----[{ font: [] }]
        [{ align: [] }], // 对齐方式-----[{ align: [] }]
        ["clean"], // 清除文本格式-----['clean']
        ["image", "video"] // 链接、图片、视频-----['link', 'image', 'video']
    ];

    export default{
        name: 'editor',
        components: {
            quillEditor,
            Upload
        },
        props:{
            text: {
                type: String,
                default: ''
            },
            width: {
                type: Number,
                default: 460
            },
            height: {
                type: Number,
                default: 750
            }
        },
        data() {
            return {
                // 富文本编辑器默认内容
                content: '',
                //富文本编辑器配置
                editorOption: {
                    // Some Quill options...
                    modules: {
                        toolbar: toolbarOptions
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入正文",
                    imageResize: {
                        displayStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            color: 'white'
                        },
                        modules: ['Resize', 'DisplaySize', 'Toolbar']
                    }
                },
                isupload: false,
                // editor: null,
            }
        },
        watch: {
            text: function (n, o) {
                if (n !== o) {
                    //this.editor.txt.html(this.text)
                }
            }
        },
        computed: {
            //当前富文本实例
            editor() {
                return this.$refs.myQuillEditor.quill;
            }
        },
        mounted() {
            var _this = this;
            var imgHandler = async function(image) {
                _this.isupload = true
            };
            _this.editor.getModule("toolbar").addHandler("image", imgHandler);
        },
        methods: {
            //失去焦点事件
            onEditorBlur(quill) {},
            //获得焦点事件
            onEditorFocus(quill) {},
            // 准备富文本编辑器
            onEditorReady(quill) {},
            //内容改变事件
            onEditorChange({ quill, html, text }) {
                this.content = html
            },
            // uploadImg: async function() {
            //     this.isupload = true
            // },

            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null) {
                    let file_length = e.length
                    console.log(file_length, 'file_length')
                    for (let i=0; i < file_length; i++) {
                        if (e[i].file_type === 'image') {
                            let Range = this.editor.getSelection();
                            console.log(Range, 'Range')
                            this.editor.insertEmbed(
                                Range != null ? Range.index : 0,
                                "image",
                                e[i]['file_path']
                            )
                            // this.editor.cmd.do('insertHTML', `<img src="${e[i].file_path}" alt="" style="max-width:100%;" />`)
                        }else if (e[i].file_type === 'video') {
                            let Range = this.editor.getSelection();
                            console.log(Range, 'Range')
                            this.editor.insertEmbed(
                                Range != null ? Range.index : 0,
                                "video",
                                e[i]['file_path']
                            )

              //               this.editor.cmd.do(
              //                   'insertHTML',
              //                   `<video width="50%" height="50%" controls>
              //   <source file-id="${e[i]['file_id']}" src="${e[i]['file_path']}" type="video/mp4">
              //   <object file-id="${e[i]['file_id']}" data="${e[i]['file_path']}" width="50%" height="50%">
              //     <embed file-id="${e[i]['file_id']}" src="${e[i]['file_path']}" width="50%" height="50%">
              //   </object>
              // </video>`
              //               )
                        }else {
                            // this.editor.cmd.do(
                            //     'insertHTML',
                            //     `<a file-id="${e[i]['file_id']}" href="${e[i]['file_path']}" download="${e[i]['file_path']}" target="_blank">${e[i]['real_name']}</el-link>`
                            // )

                            this.$message({message: '不被支持的文件类型', type: 'error'});
                            return
                        }
                    }
                }
                this.isupload = false;
            },
        },
    }
</script>
<style >
    /*.editor{*/
    /*    border: 1px solid #bcc7d3;*/
    /*}*/
    /*.toolbar{*/
    /*    border-bottom: 1px solid #bcc7d3;*/
    /*}*/

    .editor {
        /*line-height: normal !important;*/
        /*height: 400px;*/
    }
    .ql-snow .ql-tooltip[data-mode="link"]::before {
        content: "请输入链接地址:";
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: "保存";
        padding-right: 0px;
    }
    .ql-snow .ql-tooltip[data-mode="video"]::before {
        content: "请输入视频地址:";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: "14px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
        content: "10px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
        content: "18px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
        content: "32px";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: "文本";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: "标题1";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: "标题2";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: "标题3";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: "标题4";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: "标题5";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: "标题6";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: "标准字体";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
        content: "衬线字体";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
        content: "等宽字体";
    }
</style>




// WEBPACK FOOTER //
// src/components/tsk/editor-quill.vue